import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { PopupService } from "src/app/services/popup/popup.service";
import { swapItems } from "src/app/support/array";
import { translate } from "src/app/support/translate";
import {
  ReportDesignItemGrid,
  ReportDesignItemGridConfig,
  ReportDesignTablePropertyDataSourceConfig
} from "../../report-design-item";

@Component({
  selector: "snt-report-designer-table",
  templateUrl: "report-designer-table.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerTableComponent implements OnInit {
  @Input()
  item!: ReportDesignItemGrid;

  @Input()
  propertyDataSource!: ReportDesignTablePropertyDataSourceConfig;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Output()
  config: EventEmitter<ReportDesignItemGridConfig> = new EventEmitter();

  formData: { title: string; cols: string; dataType: string } = {
    title: "",
    cols: "2",
    dataType: ""
  };

  constructor(private popupService: PopupService) {}

  ngOnInit(): void {
    this.formData.title = this.item.config.title || "";
    this.formData.cols = this.item.config.cols || "2";
    this.formData.dataType = this.item.config.dataType || "";
  }

  onFieldDataChanged(): void {
    this.item.config = {
      ...this.item.config,
      ...this.formData
    };

    this.config.emit(this.item.config);
  }

  onItemReorder(dxEvent: { fromIndex: number; toIndex: number }): void {
    swapItems(this.item.config.items, dxEvent.fromIndex, dxEvent.toIndex);
  }

  async onAddField(): Promise<void> {
    await this.popupService.createEntity<{
      title: string;
      property: string;
      dataType: string;
    }>({
      title: translate(marker("Nuovo campo")),
      initialFormData: {
        title: "",
        property: "",
        dataType: "text"
      },
      formItems: [
        {
          dataField: "title",
          label: { text: translate(marker("Titolo")) },
          validationRules: [{ type: "required" }]
        },
        {
          dataField: "property",
          label: { text: translate(marker("Proprietà")) },
          editorType: "dxSelectBox",
          editorOptions: {
            valueExpr: "value",
            displayExpr: "display",
            dataSource: this.propertyDataSource
          },
          validationRules: [{ type: "required" }]
        },
        {
          dataField: "dataType",
          label: { text: translate(marker("Formato")) },
          editorType: "dxSelectBox",
          editorOptions: {
            valueExpr: "value",
            displayExpr: "display",
            dataSource: [
              {
                value: "text",
                display: translate(marker("Testo"))
              },
              {
                value: "number",
                display: translate(marker("Numerico"))
              },
              {
                value: "currency",
                display: translate(marker("Valuta"))
              },
              {
                value: "date",
                display: translate(marker("Data"))
              },
              {
                value: "datetime",
                display: translate(marker("Data ed ora"))
              },
              { value: "boolean", display: translate(marker("Booleano")) },
              { value: "translated", display: translate(marker("Tradotto")) }
            ]
          },
          validationRules: [{ type: "required" }]
        }
      ],
      create: async (data) => {
        if (!this.item.config.items) {
          this.item.config.items = [];
        }

        this.item.config.items.push({
          title: data.title,
          property: data.property,
          dataType: data.dataType
        });

        this.notifyChange();
      }
    });
  }

  onMoveUpField(index: number): void {
    swapItems(this.item.config.items, index, index - 1);
    this.notifyChange();
  }

  onMoveDownField(index: number): void {
    swapItems(this.item.config.items, index, index + 1);
    this.notifyChange();
  }

  onRemoveField(field: { title: string; property: string }): void {
    this.item.config.items = (this.item.config.items || []).filter(
      (x) => x !== field
    );

    this.notifyChange();
  }

  notifyChange(): void {
    this.config.emit(this.item.config);
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "table",
      config: {
        title: this.formData.title,
        cols: this.formData.cols,
        items:
          this.item.config?.items?.map((item: any) => ({
            title: item.title,
            value: "Demo"
          })) || []
      }
    };
  }
}
